import notificationSoundSrc from './notification.ogg';

const THROTTLE_DELAY = 2000;

/**
 * Звук фонового уведомления оператора. Решение «звучать или нет» принимает
 * вызывающий — здесь только воспроизведение.
 */
export class AppNotificationSound {
  private readonly audio: HTMLAudioElement;
  private lastPlayedAt = 0;

  constructor() {
    this.audio = new Audio(notificationSoundSrc);
    this.audio.preload = 'auto';
  }

  play = (): void => {
    const now = Date.now();

    // серия событий подряд не должна превращаться в очередь звуков
    if (now - this.lastPlayedAt < THROTTLE_DELAY) {
      return;
    }

    this.lastPlayedAt = now;
    this.audio.currentTime = 0;

    // Браузер блокирует автоплей до первого взаимодействия со страницей.
    // Это не наша ошибка и не повод для unhandled rejection на каждое событие.
    void this.audio.play().catch(() => undefined);
  };
}
